export default __webpack_public_path__ + "images/7f0b8d39d55aa82226f0d4810616add2-icon-instagram.svg";